import React, { useEffect, useState } from 'react';
import style from "./templateConfig.module.css";
import axios from 'axios';
import { ErrorToast, SuccessToast } from '../../../components/toastMessage';
import { BASE_URL } from '../../../constants/Constants';
import styles from "../../verificationPage/verifcation.module.css";
import { FileUploader } from 'react-drag-drop-files';
import { uploadSystemLogo } from "../../../utils/fileUpload";
import { useNavigate } from 'react-router-dom';
import BoxComponent from '../../../components/CommonComponents/BoxComponent/BoxComponent';
import { _axios } from '../../../utils/axios';

interface TemplateConfigState {
    municipal_council_name: string;
    tahasil_name: string;
    district_name: string;
    demand_note_header_text: string;
    certificate_header_text: string;
    demand_note_logo: string;
    certificate_logo: string;
}

function TemplateConfig() {
    const navigate = useNavigate();

    const fileTypes = ["JPG", "PNG", "JPEG"];
    const [formFields, setFormFields] = useState<TemplateConfigState>({
        municipal_council_name: "",
        tahasil_name: "",
        district_name: "",
        demand_note_header_text: "",
        certificate_header_text: "",
        demand_note_logo: "",
        certificate_logo: ""
    });

    const fetchData = async () => {
        try {
            const response = await _axios.get(`${BASE_URL}/api/controller/auto-fill`);
            if (response?.data?.success === 0) {
                ErrorToast(response?.data?.message);
                return;
            }
            const data = response?.data?.data[0];
            setFormFields({
                municipal_council_name: data?.municipal_council_name ?? '',
                tahasil_name: data?.tahasil_name ?? '',
                district_name: data?.district_name ?? '',
                demand_note_header_text: data?.demand_note_header_text ?? '',
                certificate_header_text: data?.certificate_header_text ?? '',
                demand_note_logo: data?.demand_note_logo ?? '',
                certificate_logo: data?.certificate_logo ?? ''
            });
        } catch (error) {
            ErrorToast('Error fetching data');
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleChange = (event: { target: { name: any; value: any } }) => {
        const { name, value } = event.target;
        setFormFields({ ...formFields, [name]: value });
    };

    const validateImageSize = (file: File): Promise<boolean> => {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                const isValid = img.width <= 100 && img.height <= 100;
                resolve(isValid);
            };
            img.src = URL.createObjectURL(file);
        });
    };

    const handleFileChange = async (file: File, logoType: 'demand_note_logo' | 'certificate_logo') => {
        try {
            const isValid = await validateImageSize(file);
            if (!isValid) {
                ErrorToast("Image size should not exceed 100x100 pixels");
                return;
            }

            console.log('🚀 Uploading using existing file utility...');
            
            // Use your existing file upload utility
            const blobUrl = await uploadSystemLogo(file, logoType);

            setFormFields({ ...formFields, [logoType]: blobUrl });
            SuccessToast(`${logoType.replace('_', ' ')} uploaded successfully!`);

        } catch (error) {
            ErrorToast('Error uploading file: ' + (error instanceof Error ? error.message : 'Upload failed'));
            console.error('File upload error:', error);
        }
    };

    const handleSubmit = async (event: { preventDefault: () => void }) => {
        event.preventDefault();
        try {
            const apiData = { ...formFields };
            const response = await _axios.patch(`${BASE_URL}/api/controller/auto-fill`, apiData);
            if (response?.data?.success === 0) {
                ErrorToast(response?.data?.message || 'Something went wrong!');
                return;
            }
            SuccessToast(response?.data?.message);
        } catch (error) {
            ErrorToast('Error submitting form');
        }
    };

    return (
        <div>
            <div>
                <div className={`${style.body} p-8`}>
                    <BoxComponent>
                        <div className={style.bodyContanier}>
                            <div className={style.logoUploadContainer}>
                                <div className={style.uploadsection}>
                                    <form onSubmit={handleSubmit}>
                                        <div className={style.formRow}>
                                            <div className={style.formGroup}>
                                                <p className={style.bodyTitleNormal}>Demand Note</p>
                                                <p className={style.subHeadingLabel}>
                                                    Logo
                                                    <small style={{ lineHeight: '1.4', marginLeft: '5px' }}>
                                                        {" (Maximum uploading size limit is 100X100 px)"}
                                                    </small>
                                                </p>
                                                <div className={style.uploadSection} style={{ paddingBottom: '25px' }}>
                                                    <FileUploader
                                                        handleChange={(file: File) => handleFileChange(file, 'demand_note_logo')}
                                                        name="file"
                                                        types={fileTypes}
                                                    >
                                                        <div className={style.uploadContainerDocument}>
                                                            <label className={style.uploadLable}>Browse</label>
                                                            {formFields?.demand_note_logo
                                                                ? <img src={formFields?.demand_note_logo} alt="Demand Note Logo" style={{ width: '130px', height: '70px' }} />
                                                                : 'Drag and drop file here'}
                                                        </div>
                                                    </FileUploader>
                                                </div>
                                                <label className={style.subHeadingLabel}>Header Text</label>
                                                <div className={style.passwordContainer}>
                                                    <input
                                                        className={style.InputTxtNum}
                                                        type="text"
                                                        name="demand_note_header_text"
                                                        placeholder='Enter Header Text'
                                                        value={formFields.demand_note_header_text}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className={style.formGroup}>
                                                <p className={style.bodyTitleNormal}>Certificate</p>
                                                <p className={style.subHeadingLabel}>
                                                    Logo
                                                    <small style={{ lineHeight: '1.4', marginLeft: '5px' }}>
                                                        {" (Maximum uploading size limit is 100X100 px)"}
                                                    </small>
                                                </p>
                                                <div className={style.uploadSection} style={{ paddingBottom: '25px' }}>
                                                    <FileUploader
                                                        handleChange={(file: File) => handleFileChange(file, 'certificate_logo')}
                                                        name="file"
                                                        types={fileTypes}
                                                    >
                                                        <div className={style.uploadContainerDocument}>
                                                            <label className={style.uploadLable}>Browse</label>
                                                            {formFields?.certificate_logo
                                                                ? <img src={formFields?.certificate_logo} alt="Certificate Logo" style={{ width: '130px', height: '70px' }} />
                                                                : 'Drag and drop file here'}
                                                        </div>
                                                    </FileUploader>
                                                </div>
                                                <label className={style.subHeadingLabel}>Header Text</label>
                                                <div className={style.passwordContainer}>
                                                    <input
                                                        className={style.InputTxtNum}
                                                        type="text"
                                                        name="certificate_header_text"
                                                        placeholder='Enter Header Text'
                                                        value={formFields.certificate_header_text}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className={style.buttonSection}>
                                            <button type='submit' className={'bg-primary ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300 disabled:text-gray-500 mb-5'}>
                                                Publish
                                            </button>

                                            <button type='button' className={'bg-black ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300 disabled:text-gray-500 mb-5'} onClick={() => navigate('/dashboard')}>
                                                Close
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </BoxComponent>
                </div>
            </div>
        </div>
    );
}

export default TemplateConfig;
